import React, {useRef, useState} from 'react';
import {Paperclip} from 'react-feather';
import Tooltip from "../Common/Tooltip";
import {uploadConversationFile} from "../../services/api/messaging";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const FileUpload = ({onUploading, onUploaded}) => {
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const handleFileSelect = async () => {
        setLoading(true);
        const file = fileInputRef.current.files[0];
        if (!file) {
            setLoading(false);
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            onUploading({name: file.name, size: file.size, error: "You can't upload files larger than 5 MB."});
            fileInputRef.current.value = null;
            setLoading(false);
            onUploaded();
            return;
        }

        onUploading({name: file.name});
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await uploadConversationFile(formData);
            onUploading(response.data);
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setLoading(false);
            fileInputRef.current.value = null;
            onUploaded();
        }
    };

    return (
        <div className="sl-form-uploads">
            <input
                disabled={loading}
                ref={fileInputRef}
                className="sl-hidden"
                type="file"
                name="file"
                onChange={handleFileSelect}
            />
            <Tooltip content="Upload a file" disabled={loading}>
                <button
                    className="sl-btn sl-btn-md sl-btn-clear sl-p-2-point-5 sl-max-h-10 sl-max-w-10"
                    onClick={() => fileInputRef.current.click()}
                >
                    <Paperclip size={20}/>
                </button>
            </Tooltip>
        </div>
    );
};

export default FileUpload;
